
import { useState, useEffect } from 'react';
import { useOnboardingContext } from '@/context/OnboardingContext';

interface UserData {
  id: string;
  name: string | null;
  email: string;
  phone_number: string | null;
}

export const useUserData = () => {
  const [userData, setUserData] = useState<UserData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { userData: onboardingData, isLoading: onboardingLoading } = useOnboardingContext() || { userData: null, isLoading: true };

  useEffect(() => {
    const loadUserData = async () => {
      try {
        setIsLoading(true);
        setError(null);
        console.log('useUserData - Chargement des données utilisateur - onboardingData:', onboardingData);
        console.log('useUserData - onboardingLoading:', onboardingLoading);
        
        // Wait for onboarding context to finish loading
        if (onboardingLoading) {
          console.log('useUserData - Attente du chargement du contexte d\'onboarding...');
          return;
        }
        
        // Délai pour simuler le chargement et éviter les erreurs de timing
        await new Promise(resolve => setTimeout(resolve, 100));
        
        if (!onboardingData) {
          console.log('useUserData - Aucune donnée d\'onboarding trouvée');
          setError('Veuillez d\'abord compléter votre profil');
          return;
        }

        if (!onboardingData.email) {
          console.log('useUserData - Email manquant dans les données d\'onboarding');
          setError('Adresse email manquante dans votre profil');
          return;
        }

        // Check if onboarding is completed
        if (!onboardingData.onboardingCompleted) {
          console.log('useUserData - Onboarding non complété');
          setError('Veuillez d\'abord compléter votre inscription');
          return;
        }

        // Convertir les données du contexte d'onboarding au format attendu
        const convertedUserData: UserData = {
          id: onboardingData.email, // Utiliser l'email comme ID unique
          name: onboardingData.name || '',
          email: onboardingData.email || '',
          phone_number: onboardingData.phoneNumber || ''
        };

        console.log('useUserData - Données utilisateur converties avec succès:', convertedUserData);
        setUserData(convertedUserData);
        setError(null);
      } catch (err) {
        console.error('useUserData - Erreur lors de la récupération des données utilisateur:', err);
        setError('Impossible de charger vos informations. Veuillez réessayer.');
      } finally {
        setIsLoading(false);
      }
    };

    loadUserData();
  }, [onboardingData, onboardingLoading]);

  return { userData, isLoading, error };
};
